// src/pages/Home.js
import React from 'react';
import HeroVideo from '../components/home/HeroVideo';
import AboutSection from '../components/home/AboutSection';
import NewsSection from '../components/home/NewsSection';
import PartnersSection from '../components/home/PartnersSection';

function Home() {
  return (
    <div>
      <HeroVideo />
      <AboutSection />
      <NewsSection />
      <PartnersSection />
    </div>
  );
}

export default Home;